import Crum from '@/components/Crum';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import SupportBanner from '@/components/SupportCommon/SupportBanner';
import SupportContactUsPc from '@/components/SupportCommon/SupportContactUs';
import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import EFQuestionMark from '@/components/UI/svg/Icons/EFQuestionMark';
import SupportContactUsH5 from '@/componentsH5/SupportCommon/SupportContactUs';
import seoconfig from '@/seoconfig/support/warranty';
import { createProductRegistration, getBuyWays, getCountriesList, getSkuBySN } from '@/service';
import { getIsLogin } from '@/utils/cookie';
import { getCountryRegion } from '@/utils/countryRegion';
import { localValueMap } from '@/utils/locals';
import { setLocalStorage } from '@/utils/localStorage';
import generateTraceId from '@/utils/singUtil/generateTraceId';
import { useGlobal } from '@/utils/useGlobal';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import PlusOutlined from '@ant-design/icons/PlusOutlined';
import OSS from 'ali-oss';
import { Button, DatePicker, Form, Input, message, Modal, Select, Tooltip, Upload } from 'antd';
import type { RcFile, UploadFile, UploadProps } from 'antd/lib/upload/interface';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import React from 'react';
import css from './index.module.scss';
import { signupCookie } from '@/utils/cookies/signupCookie';
const { Option } = Select;
export default function Warranty({ lang, SEO }: any) {
    const { useState, useEffect, useRouter, isMobile, useLang, gtm } = useGlobal();
    const router = useRouter();
    const { locale } = useRouter();
    const [form] = Form.useForm<formDataType>();
    const [channels, setChannels] = useState([]);
    const [prefixCode, setPrefixCode] = useState('');
    const [countryList, setCountryList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showOtherChannelInput, setShowOtherChannelInput] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const SupportContactUs = isMobile ? SupportContactUsH5 : SupportContactUsPc;
    const [selectOpen, setSelectOpen] = useState({
        buyWayOpen: false,
        productsOpen: false,
    });
    const { t } = useLang('shared');
    const breadcrumbData = [{ name: t('crums.crum_home'), link: '/' }, { name: t('crums.crum_support'), link: '/support' }, { name: t('crums.crum_warranty') }];

    const [fileList, setFileList] = useState([] as UploadFile[]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const MAX_FILE_NUM = 5;

    const [showPhoneErrorMsg, setShowPhoneErrorMsg] = useState(false);
    const [showSNErrorMsg, setShowSNErrorMsg] = useState(false); // 前端输入格式错误
    const [errorMsgSN, setErrorMsgSN] = useState(''); // 后端返回
    const isEU = getCountryRegion(locale) === 'eu';
    const HOST_STS = isEU ? process.env.NEXT_PUBLIC_STS_HOST_EU : process.env.NEXT_PUBLIC_STS_HOST;

    type formDataType = {
        buyTime: string | null;
        buyWay: string | null;
        productType: string | null;
        sn: string | null;
        otherChannel: string | null;
        specify: string | null;
        phone: string | null;
        orderProofs: any;
        ifOther: string;
        country: any;
    };

    // 获取购买渠道
    const initBuyWays = async (key?: string) => {
        const res = await getBuyWays({ buyWay: key });
        if (res?.code === '0') {
            setChannels(res?.data);
        } else {
            setChannels([]);
        }
    };

    // 是否可以延保
    const [isExtendedWarrantyProduct, setIsExtendedWarrantyProduct] = useState(false);
    // 根据sn码获得sku
    const getProductsBySn = async (sn: string) => {
        try {
            setLoading(true);
            const res = await getSkuBySN(sn);
            if (res.code === '0') {
                if (isEmpty(res.data)) {
                    // 返回为空，放开product name,让用户手动输入
                    form.setFieldsValue({
                        productType: null,
                    });
                    setLoading(false);
                    setErrorMsgSN(res.message);
                    return;
                }
                form.setFieldsValue({
                    productType: res.data?.productName,
                });
                setLoading(false);
                setErrorMsgSN('');
                setIsExtendedWarrantyProduct(!!res.data?.isExtendedWarrantyProduct);
            } else {
                form.setFieldsValue({
                    productType: null,
                });
                setLoading(false);
                setErrorMsgSN(res.message);
            }
        } catch {}
    };
    const [snValue, setSnValue] = useState('');
    const onSNInputChange = (e: any) => {
        setSnValue(e.target.value);
        // 限制只能输入数字或者字母
        e.target.value = e.target.value.replace(/[^a-zA-Z0-9$]/g, '');
        const value = e.target.value || '';
        // 限制必须是15或者16位
        if (value.length === 15 || value.length === 16) {
            showSNErrorMsg && setShowSNErrorMsg(false);
            getProductsBySn(value).finally(() => {
                onValuesChange(null, form.getFieldsValue());
            });
        }
        if (![15, 16].includes(value.length)) {
            form.setFieldsValue({
                productType: null,
            });
        }
    };

    // 字段值发生变化回调
    const onValuesChange = (_: any, allValues: formDataType) => {
        const { sn, productType, buyWay, buyTime, phone } = allValues;
        if (
            sn &&
            [15, 16].includes(sn.length) &&
            productType &&
            buyWay &&
            // buyTime &&
            fileList?.length &&
            (!phone || (phone?.length >= 7 && phone?.length <= 20))
        ) {
            return submitDisabled && setSubmitDisabled(false);
        } else {
            return !submitDisabled && setSubmitDisabled(true);
        }
    };

    // 创建产品注册
    const submit = async (formData: any) => {
        setSubmitLoading(true);
        const cloneFormData = cloneDeep(formData);
        cloneFormData.phone = formData.phone ? `${prefixCode} ${formData.phone}` : '';
        // if (cloneFormData.buyTime) {
        //     cloneFormData.buyTime = moment(cloneFormData.buyTime).format('YYYY-MM-DD');
        // }
        cloneFormData.ifOther = String(channels?.find((channel: any) => channel?.buyWay === cloneFormData?.buyWay)?.ifOther);
        cloneFormData.region = cloneFormData?.country?.value || cloneFormData?.country?.key || cloneFormData?.country;

        const dateNow = new Date();
        const year = dateNow.getFullYear();
        const month = String(dateNow.getMonth() + 1).padStart(2, '0');
        const day = String(dateNow.getDate()).padStart(2, '0');
        const timestamp = dateNow.getTime();

        // 0531-0601 @凌国鑫 由于原有方式存在XSS攻击风险，改为通过STS服务将客户上传文件直传到阿里云oss上， 原有注册接口只存一个阿里云链接字符串
        let json1: any = { data: { region: '', bucket: '', endpoint: '' }, code: '' };
        const result1 = await fetch(`${HOST_STS}/system/oss/fileUpload/prepareSts`, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        });
        json1 = await result1.json();

        const arr: any[] = [];
        const uuidArr: any[] = [];
        formData?.orderProofs?.map((file: string, i: number) => {
            const tempArr = file?.url?.split('.');
            const suffix = tempArr[tempArr.length - 1];
            const uuid = generateTraceId();
            uuidArr.push(uuid);
            arr.push({
                url: `https://${json1?.data?.bucket}.${json1?.data?.endpoint}/app/user/warranty/${year}/${month}/${day}/${timestamp}/${uuid}.${suffix}`,
            });
        });
        cloneFormData.orderProofs = arr;
        await handleAsyncToOSS(
            formData?.orderProofs,
            { year, month, day, timestamp, region: json1?.data?.region, bucket: json1?.data?.bucket },
            uuidArr,
            cloneFormData,
        );

        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'register_product',
                button: 'register_now',
            });
        } catch (e) {
            console.error(e);
        }
    };
    const dateFormat = 'DD / MM / YYYY';
    const dropdownRender = (menu: React.ReactElement) => <div>{menu}</div>;

    const bgImage = isMobile ? '/img/mobile/support/warranty_m.png' : '/img/supportWarrantyBanner.jpg';

    const onCountryChange = (e: any) => {
        const { value } = e;
        const target = countryList.filter((item: any) => item.text === value);

        if (target?.length) {
            const [item] = target;
            setPrefixCode(item.phoneCode);
        }
    };

    const getCountries = async () => {
        try {
            const res: any = await getCountriesList({
                page: 1,
                size: 250,
            });
            if (res?.code === '0') {
                const cl = res?.data?.content?.map((item: any) => ({
                    key: item.id,
                    text: item.name,
                    phoneCode: item.phoneCode,
                }));
                const arr = [...countryList, ...cl];
                setCountryList(arr);
                const curCountry = arr?.find((list: any) => {
                    return (
                        localValueMap[locale]?.region?.toLowerCase() === list?.text?.toLowerCase() ||
                        localValueMap[locale]?.regionForWarranty?.toLowerCase() === list?.text?.toLowerCase()
                    );
                });
                form.setFieldsValue({ country: curCountry?.text });
                // 蛋疼...不知道为何，上面这行setFieldsValue在开发测试环境经常出现不生效的情况，导致country那一栏不会显示默认值， 不得已用下面代码硬性兼容解决这个问题
                setTimeout(() => {
                    const countryEl = document.querySelector('.selectCountry .ant-select-selection-item') as HTMLElement;
                    if (countryEl && !countryEl?.innerText) {
                        countryEl.innerText = countryEl ? curCountry?.text : '';
                    }
                    setPrefixCode(curCountry?.phoneCode);
                }, 100);
                // end
            }
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        if (!getIsLogin()) {
            const { origin } = window.location;
            signupCookie?.({
                page_url: `${origin}/${locale}/support`,
                sector_name: 'Support Services',
                entry_position: 2,
            });
            router.push(`/${locale}/login?redirect=${locale}/support/warranty`);
            return;
        }
        initBuyWays().catch();
        getCountries().catch();
    }, []);

    const uploadButton = (
        <div>
            <PlusOutlined />
        </div>
    );

    const handleCancel = () => setPreviewVisible(false);

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as RcFile);
        }
        setPreviewImage(file.url || (file.preview as string));
        setPreviewVisible(true);
        setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
    };

    useEffect(() => {
        if (fileList?.length <= 0 && !submitDisabled) {
            setSubmitDisabled(true);
        }
        if (fileList?.length > 0) {
            onValuesChange(null, form.getFieldsValue());
        }
    }, [fileList]);

    const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
        const filesArr: string[] = [];
        const lists = newFileList?.map((file: any) => {
            if (file?.status === 'done' && file?.response && file?.response?.code === '0') {
                filesArr.push(file?.response?.data);
            }
            return {
                uid: file?.uid,
                name: file?.name,
                url: file?.originFileObj?.name,
                lastModified: file?.lastModified,
                type: file?.type,
                size: file?.size,
            };
        });
        setFileList(newFileList);
        form.setFieldsValue({ orderProofs: lists?.map((list: any) => ({ url: list?.url })) });
    };

    // 0531-0601 @凌国鑫 由于原有方式存在XSS攻击风险，改为通过STS服务将客户上传文件直传到阿里云oss上， 原有注册接口只存一个阿里云链接字符串
    const handleAsyncToOSS = async (filesArr: any, dateTime: any, uuidArr: any, cloneFormData: any) => {
        const { year, month, day, timestamp, region, bucket } = dateTime;
        try {
            const result2 = await fetch(`${HOST_STS}/system/oss/fileUpload/stsServer`, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            const json2 = await result2.json();
            if (json2?.StatusCode === '200') {
                const { AccessKeyId: accessKeyId, AccessKeySecret: accessKeySecret, SecurityToken: stsToken } = json2;
                const client = new OSS({
                    // yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
                    region,
                    // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                    accessKeyId,
                    accessKeySecret,
                    // 从STS服务获取的安全令牌（SecurityToken）。
                    stsToken,
                    // 填写Bucket名称。
                    bucket,
                });
                filesArr?.map(async (file: any, i: number) => {
                    const tempArr = file?.url?.split('.');
                    const suffix = tempArr[tempArr.length - 1];
                    const rrrw = await client.put(
                        `/app/user/warranty/${year}/${month}/${day}/${timestamp}/${uuidArr[i]}.${suffix}`,
                        fileList[i]?.originFileObj,
                        {
                            headers: {
                                'x-oss-object-acl': 'private', // 设为私有，不可直接访问
                            },
                        },
                    );
                    if (i === filesArr.length - 1 && rrrw?.res?.statusCode === 200) {
                        try {
                            const res = await createProductRegistration(cloneFormData);
                            if (res.code === '0') {
                                // 提交成功，直接跳转
                                setLocalStorage('myDeviceFrom', '1');
                                // router.push(`/${locale}/my?tab=device&from=/support/warranty`);
                                router.push(`/${locale}/my-assets-devices`);
                                if (isExtendedWarrantyProduct) {
                                    message.success(lang.registerSuccess);
                                }
                                return;
                            }
                            setSubmitLoading(false); // 提交失败，关闭loading
                            message.error(res.message || 'network error');
                        } catch {
                            setSubmitLoading(false);
                            message.error('network error');
                        }
                    }
                });
            }
        } catch (e) {
            setSubmitLoading(false);
            console.log(e);
        }
    };

    const handleRemove: UploadProps['onRemove'] = (file: any) => {
        const newList = fileList?.filter((list: any) => file?.uid !== list.uid);
        setFileList(newList);
        const lists = newList?.map((file: any) => ({
            uid: file?.uid,
            name: file?.name,
            url: file?.response?.data,
            lastModified: file?.lastModified,
            type: file?.type,
            size: file?.size,
        }));
        form.setFieldsValue({ orderProofs: lists?.map((list: any) => ({ url: list?.url })) });
        return true;
    };

    const getBase64 = (file: RcFile): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });
    const [showMsg, setShowMsg] = useState(false);
    const onBlurSN = (e: any) => {
        setShowMsg(true);
        if (![15, 16].includes(e.target.value.length) || errorMsgSN) {
            setShowSNErrorMsg(true);
        }
    };

    // ecocredits 页面 push 过来携带 body hidden, 需要手动清除
    useEffect(() => {
        if (typeof window !== 'undefined') {
            document.body.style.overflow = 'auto';
        }
    }, []);

    return (
        <PageLayout isNoFixed={true}>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <div
                className={`${css.warrantyContainer} GtmModuleData-section`}
                data-section-id={'warranty'}
                data-section-title={lang.site_support_warranty_title}
            >
                <div className="warrantyHead">
                    <SupportBanner
                        title={lang.site_support_warranty_title}
                        subTitle={isMobile && router.locale === 'jp' ? lang.site_support_warranty_title_note_h5 : lang.site_support_warranty_title_note}
                        bgImages={bgImage}
                        isSearch={false}
                    />
                </div>
                {locale !== 'eu' && <Crum data={breadcrumbData} />}
                <div className="container">
                    <Form form={form} onValuesChange={onValuesChange} onFinish={submit} className="warrantyForm" autoComplete="off" layout="vertical">
                        {/* SN: Serial Number */}
                        <Form.Item label={lang.site_support_warranty_sn} name="sn" validateFirst={true} rules={[{ required: true, message: '' }]}>
                            <Input
                                className="cInput"
                                size="large"
                                onInput={onSNInputChange}
                                onBlur={onBlurSN}
                                onFocus={() => {
                                    setShowMsg(false);
                                    setShowSNErrorMsg(false);
                                }}
                                maxLength={16}
                                minLength={15}
                                suffix={
                                    loading ? (
                                        <LoadingOutlined style={{ color: '#919191' }} />
                                    ) : (
                                        <Tooltip title={lang.site_support_warranty_sn_empty}>
                                            <EFQuestionMark className="questionIcon" />
                                        </Tooltip>
                                    )
                                }
                                placeholder={lang.site_support_warranty_sn_empty}
                                aria-label={lang.site_support_warranty_sn}
                            />
                        </Form.Item>
                        {showMsg && showSNErrorMsg && <p className="errorMsg">{errorMsgSN || lang.site_support_warranty_sn_wrong}</p>}
                        {isExtendedWarrantyProduct && showMsg && !showSNErrorMsg && !loading && !!snValue && (
                            <p className="sn-confirm">{lang.site_support_warranty_sn_confirm}</p>
                        )}
                        {/* 产品名: Product Name */}
                        <Form.Item label={lang.site_support_warranty_product} name="productType" rules={[{ required: true, message: '' }]}>
                            <Select
                                disabled
                                className="cSelect"
                                dropdownClassName={css.efDropdownSelect}
                                dropdownRender={(menu) => dropdownRender(menu)}
                                placeholder={lang.site_support_warranty_product}
                                listItemHeight={56}
                                listHeight={376}
                                onDropdownVisibleChange={(open) => setSelectOpen({ buyWayOpen: false, productsOpen: open })}
                                suffixIcon={null}
                            ></Select>
                        </Form.Item>
                        {/* 购买渠道: Purchased From */}
                        <Form.Item label={lang.site_support_warranty_purchase_form} name="buyWay" rules={[{ required: true, message: '' }]}>
                            <Select
                                className="cSelect"
                                dropdownClassName={css.efDropdownSelect}
                                dropdownRender={(menu) => dropdownRender(menu)}
                                placeholder={lang.site_support_warranty_channels}
                                listItemHeight={56}
                                listHeight={376}
                                onChange={debounce((value) =>
                                    setShowOtherChannelInput(String(channels?.find((channel: any) => channel?.buyWay === value)?.ifOther) === 'true'),
                                )}
                                onDropdownVisibleChange={(open) => setSelectOpen({ productsOpen: false, buyWayOpen: open })}
                                suffixIcon={
                                    <div
                                        style={{
                                            transform: `rotate(${selectOpen.buyWayOpen ? '90deg' : '0deg'})`,
                                        }}
                                    >
                                        <Image src="/icons/arrow-black.svg" width={20} height={20} alt={t('support.warranty.arrow_icon')} />
                                    </div>
                                }
                            >
                                {channels?.map((channel: any, index: number) => (
                                    <Option key={index} value={channel?.buyWay}>
                                        {channel?.buyWay}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                        {/* 购买渠道 - 其他 */}
                        {showOtherChannelInput && (
                            <Form.Item name="specify" required>
                                <Input
                                    className="cInput otherChannel"
                                    size="large"
                                    placeholder={t('support.warranty.specify')}
                                    aria-label={t('support.warranty.specify')}
                                />
                            </Form.Item>
                        )}
                        {/* 购买日期: Purchase Date */}
                        {/* <Form.Item label={lang.site_support_warranty_purchase_date} name="buyTime" rules={[{ required: true, message: '' }]}>
                            <DatePicker
                                className="cDatePicker"
                                inputReadOnly={true}
                                placeholder={lang.site_support_warranty_purchase_date_day}
                                aria-label={lang.site_support_warranty_purchase_date}
                                dropdownClassName={css.cDatePickerDropdown}
                                format={dateFormat}
                                disabledDate={(current) => current && current > moment().endOf('day')}
                                suffixIcon={<Image src="/icons/date.svg" width={20} height={20} alt={t('support.warranty.date')} />}
                                showToday={false}
                                allowClear={false}
                            />
                        </Form.Item> */}
                        {/* 国家/地区: Country/Region */}
                        <Form.Item name="country" label={t('my.site_account_address_country')}>
                            <Select
                                className="cSelect selectCountry"
                                placeholder={t('my.site_account_address_country')}
                                onChange={onCountryChange}
                                optionFilterProp="children"
                                showSearch
                                onDropdownVisibleChange={(open) => {
                                    setSelectOpen({
                                        ...selectOpen,
                                        ...{
                                            countryOpen: open,
                                        },
                                    });
                                }}
                                getPopupContainer={(triggerNode: any) => triggerNode.parentNode || document.body}
                                suffixIcon={
                                    <div
                                        style={{
                                            transform: `rotate(${selectOpen.countryOpen ? '0deg' : '-90deg'})`,
                                        }}
                                    >
                                        <EFArrowDown style={{ fontSize: '14px', color: '#03060b' }} />
                                    </div>
                                }
                                dropdownClassName="ef-select-item"
                                labelInValue
                            >
                                {(['us', 'ca'].includes(locale) ? countryList?.filter((list: any) => list.key !== 178) : countryList)?.map(
                                    (item: any, index: number) => (
                                        <Option value={item.text} key={index}>
                                            {item.text}
                                        </Option>
                                    ),
                                )}
                            </Select>
                        </Form.Item>
                        {/* 电话号码: Phone Number */}
                        <Form.Item name="phone" className="phone_input" label={lang.site_support_warranty_phone}>
                            <Input
                                className="default-input vertical-line cInput"
                                placeholder={lang.site_support_warranty_phone_empty}
                                aria-label={lang.site_support_warranty_phone}
                                prefix={
                                    prefixCode && (
                                        <>
                                            <span>{prefixCode}</span>
                                            <div className="divider"></div>
                                        </>
                                    )
                                }
                                maxLength={20}
                                minLength={7}
                                onInput={(e: any) => {
                                    // 不允许输入非数字
                                    e.target.value = e.target.value.replace(/\D/g, '');
                                    // 必须7~20位之间
                                    if ((e.target.value.length >= 7 && e.target.value.length <= 20) || e.target.value.length === 0) {
                                        form.setFieldsValue({ phone: e?.target?.value });
                                    }
                                    return;
                                }}
                                onFocus={() => showPhoneErrorMsg && setShowPhoneErrorMsg(false)}
                                onBlur={(e: any) => {
                                    if ((e.target.value.length !== 0 && e.target.value.length < 7) || e.target.value.length > 20) {
                                        setShowPhoneErrorMsg(true);
                                    }
                                }}
                            />
                        </Form.Item>
                        {showPhoneErrorMsg && <p className="errorMsg">{lang.site_support_warranty_phone_wrong}</p>}
                        {/* 订单证明: Order Proof */}
                        <Form.Item
                            name="orderProofs"
                            className={`imgs_upload ${fileList?.length ? '' : 'noFile'}`}
                            required
                            label={`${lang.site_support_warranty_order_proof} (${fileList?.length}/${MAX_FILE_NUM})`}
                        >
                            {['jp'].includes(locale) && <p className="des">{lang.site_support_warranty_order_proof_des}</p>}
                            <Upload
                                action=""
                                name="upload"
                                accept="image/jpeg, image/png, image/gif, image/webp, .pdf"
                                listType="picture-card"
                                fileList={fileList}
                                onPreview={handlePreview}
                                onChange={handleChange}
                                onRemove={handleRemove}
                                beforeUpload={(file: any) => {
                                    // 限制为图片或者10M以内的pdf文件
                                    if (
                                        (file.type !== 'application/pdf' && !file.type.startsWith('image/')) ||
                                        ['image/svg+xml', 'image/x-icon'].includes(file.type) ||
                                        (file.type === 'application/pdf' && file.size / 1024 / 1024 > 10)
                                    ) {
                                        message.error(lang.site_support_warranty_order_proof_img_wrong);
                                        return Upload.LIST_IGNORE;
                                    }
                                    return true;
                                }}
                            >
                                {fileList?.length >= MAX_FILE_NUM ? null : uploadButton}
                            </Upload>
                        </Form.Item>

                        {/* 提交按钮: Register Now */}
                        <Form.Item>
                            <Button
                                disabled={submitDisabled}
                                loading={submitLoading}
                                className={`submit font-family-semibold ${submitDisabled ? 'disabled' : ''}`}
                                htmlType="submit"
                                aria-label={lang.site_support_warranty_register}
                            >
                                {lang.site_support_warranty_register}
                            </Button>
                        </Form.Item>
                    </Form>
                    <SupportContactUs isShow={true} />
                </div>
            </div>
            <Modal visible={previewVisible} title={previewTitle} footer={null} onCancel={handleCancel}>
                <img alt="example" style={{ width: '100%' }} src={previewImage} />
            </Modal>
        </PageLayout>
    );
}
